export function vehicleProgressStatus(v) {
    if (!v) {
        return null;
    }
    if (v.completed || v.completedDateTime) {
        return { key: 'completed', label: 'Completed', at: v.completedDateTime || null };
    }
    if (v.turnAroundTime) {
        return { key: 'turnedAround', label: 'Turned around', at: v.turnAroundTime };
    }
    if (v.actualDepartDateTime) {
        return { key: 'enRoute', label: 'En route', at: v.actualDepartDateTime };
    }
    if (v.pickedUpDateTime) {
        return { key: 'pickedUp', label: 'Picked up', at: v.pickedUpDateTime };
    }
    return null;
}

export function formatProgressTime(at) {
    if (!at) {
        return '';
    }
    const d = new Date(at);
    if (Number.isNaN(d.getTime())) {
        return '';
    }
    return d.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    });
}

export function progressModifier(key) {
    return {
        pickedUp: 'pickedup',
        enRoute: 'enroute',
        turnedAround: 'turned',
        completed: 'completed',
    }[key] || '';
}
